import { Component } from '@angular/core';

@Component({
    selector: 'bb-card-vendor-page-ui',
    templateUrl: './bb-card-vendor-page-ui.component.html',
    standalone: false,
})
export class CardVendorPageComponent {}
